import Modal from './Modal.container';
import * as actions from './Modal.actions';
import reducer from './Modal.reducer';
import * as selectors from './Modal.selectors';
import * as types from './Modal.interface';
import { useModal } from './useModal';

export default Modal;
export { actions, useModal, reducer, selectors, types };
